import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import {
  IJobType, IJobTypeCreatePayload, IJobTypeUpdatePayload,
  IJobStatusPipeline, IJobStatusPipelineCreatePayload, IJobStatusPipelineUpdatePayload,
  IJobStatusStageCreatePayload, IJobStatusStageUpdatePayload,
  IChecklistTemplate, IChecklistCreatePayload, IChecklistUpdatePayload,
  IFormTemplate, IFormTemplateCreatePayload, IFormTemplateUpdatePayload,
  ICertificationType, IRequiredCertification,
} from "../../../types/api/job-config";

// Job Types
export async function listJobTypes(params: any): Promise<AxiosResponse<TResponseWithQData<IJobType[]>>> {
  return axios.get(API_ENDPOINTS.JOB_TYPE_LIST, { params });
}
export async function createJobType(data: IJobTypeCreatePayload): Promise<AxiosResponse<TResponse<IJobType>>> {
  return axios.post<TResponse<IJobType>>(API_ENDPOINTS.JOB_TYPE_CREATE, data);
}
export async function updateJobType(data: IJobTypeUpdatePayload): Promise<AxiosResponse<TResponse<IJobType>>> {
  return axios.post<TResponse<IJobType>>(API_ENDPOINTS.JOB_TYPE_UPDATE, data);
}
export async function deleteJobType(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.JOB_TYPE_DELETE, { id });
}

// Required Certifications
export async function listCertificationTypes(): Promise<AxiosResponse<TResponse<ICertificationType[]>>> {
  return axios.get(API_ENDPOINTS.JOB_TYPE_CERTIFICATION_TYPES_LIST);
}
export async function listRequiredCertifications(jobTypeId: number): Promise<AxiosResponse<TResponse<IRequiredCertification[]>>> {
  return axios.get(`${API_ENDPOINTS.JOB_TYPE_REQUIRED_CERTIFICATIONS}/${jobTypeId}/required-certifications`);
}
export async function saveRequiredCertifications(jobTypeId: number, certification_names: string[]): Promise<AxiosResponse<TResponse<any>>> {
  return axios.post(`${API_ENDPOINTS.JOB_TYPE_REQUIRED_CERTIFICATIONS}/${jobTypeId}/required-certifications`, { certification_names });
}

// Pipelines
export async function listPipelines(params?: any): Promise<AxiosResponse<TResponse<IJobStatusPipeline[]>>> {
  return axios.get(API_ENDPOINTS.PIPELINE_LIST, { params });
}
export async function createPipeline(data: IJobStatusPipelineCreatePayload): Promise<AxiosResponse<TResponse<IJobStatusPipeline>>> {
  return axios.post<TResponse<IJobStatusPipeline>>(API_ENDPOINTS.PIPELINE_CREATE, data);
}
export async function updatePipeline(data: IJobStatusPipelineUpdatePayload): Promise<AxiosResponse<TResponse<IJobStatusPipeline>>> {
  return axios.post<TResponse<IJobStatusPipeline>>(API_ENDPOINTS.PIPELINE_UPDATE, data);
}
export async function deletePipeline(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.PIPELINE_DELETE, { id });
}

// Stages
export async function createStage(data: IJobStatusStageCreatePayload): Promise<AxiosResponse<TResponse<any>>> {
  return axios.post(API_ENDPOINTS.STAGE_CREATE, data);
}
export async function updateStage(data: IJobStatusStageUpdatePayload): Promise<AxiosResponse<TResponse<any>>> {
  return axios.post(API_ENDPOINTS.STAGE_UPDATE, data);
}
export async function deleteStage(id: number, force?: boolean): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.STAGE_DELETE, { id, force });
}

// Checklists
export async function listChecklists(params: any): Promise<AxiosResponse<TResponseWithQData<IChecklistTemplate[]>>> {
  return axios.get(API_ENDPOINTS.CHECKLIST_LIST, { params });
}
export async function checklistDetail(id: number): Promise<AxiosResponse<TResponse<IChecklistTemplate>>> {
  return axios.get(`${API_ENDPOINTS.CHECKLIST_DETAIL}/${id}`);
}
export async function createChecklist(data: IChecklistCreatePayload): Promise<AxiosResponse<TResponse<IChecklistTemplate>>> {
  return axios.post<TResponse<IChecklistTemplate>>(API_ENDPOINTS.CHECKLIST_CREATE, data);
}
export async function updateChecklist(data: IChecklistUpdatePayload): Promise<AxiosResponse<TResponse<IChecklistTemplate>>> {
  return axios.post<TResponse<IChecklistTemplate>>(API_ENDPOINTS.CHECKLIST_UPDATE, data);
}
export async function deleteChecklist(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.CHECKLIST_DELETE, { id });
}
export async function saveChecklistItems(data: { template_id: number; items: any[] }): Promise<AxiosResponse<TResponse<IChecklistTemplate>>> {
  return axios.post<TResponse<IChecklistTemplate>>(API_ENDPOINTS.CHECKLIST_SAVE_ITEMS, data);
}

// Form Templates
export async function listFormTemplates(params: any): Promise<AxiosResponse<TResponseWithQData<IFormTemplate[]>>> {
  return axios.get(API_ENDPOINTS.FORM_TEMPLATE_LIST, { params });
}
export async function formTemplateDetail(id: number): Promise<AxiosResponse<TResponse<IFormTemplate>>> {
  return axios.get(`${API_ENDPOINTS.FORM_TEMPLATE_DETAIL}/${id}`);
}
export async function createFormTemplate(data: IFormTemplateCreatePayload): Promise<AxiosResponse<TResponse<IFormTemplate>>> {
  return axios.post<TResponse<IFormTemplate>>(API_ENDPOINTS.FORM_TEMPLATE_CREATE, data);
}
export async function updateFormTemplate(data: IFormTemplateUpdatePayload): Promise<AxiosResponse<TResponse<IFormTemplate>>> {
  return axios.post<TResponse<IFormTemplate>>(API_ENDPOINTS.FORM_TEMPLATE_UPDATE, data);
}
export async function deleteFormTemplate(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.FORM_TEMPLATE_DELETE, { id });
}
